import parse from "html-react-parser";
import { DropdownElementType, OptionType } from "../helpers/types";

type Props = {
    value: string;
    error: string | null;
    onChange: (value: string) => void;
};

const Dropdown = (props: DropdownElementType & Props) => {
    const { value, error, label, options, placeholder, onChange, description } = props;

    const Option = ({ item }: { item: OptionType }) => {
        const handleChange = () => {
            onChange(item.value);
        }

        return (
            <li
                className={`dropdown-item ${value && value === item.value ? 'bg-primary-subtle' : ''}`}
                onClick={handleChange}
            >
                {item.label}
            </li>
        );
    }

    return (
        <>
            <label className="form-label">{label}</label>
            {description && <div className="text-muted small mb-2">{parse(description)}</div>}
            <div className={`dropdown ${error && value ? 'is-invalid' : value ? 'is-valid' : ''}`}>
                <div className={`dropdown-toggle form-control d-flex align-items-center`} data-bs-toggle="dropdown" aria-expanded="false">
                    <span>{value && value !== '' ? options.find((item) => item.value === value)?.label : placeholder}</span>
                </div>
                <ul className="dropdown-menu dropdown-options w-100">
                    {options.map((item, index) => (
                        <Option
                            key={index}
                            item={item}
                        />
                    ))}
                </ul>
            </div>
            {error && value && <div className="invalid-feedback">{parse(error)}</div>}
        </>
    )
}

export default Dropdown;